import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  BankCode: any;
  CompanyUUID: any;
  Date: any;
};

export type AddAdminInput = {
  userSub: Scalars["String"];
};

export type AddAdminPayload = {
  __typename?: "AddAdminPayload";
  result: Scalars["Boolean"];
};

export type Admin = {
  __typename?: "Admin";
  name: Scalars["String"];
  userSub: Scalars["ID"];
};

export type AdminUserAtMikatanoId = {
  __typename?: "AdminUserAtMikatanoID";
  email: Scalars["String"];
  firstName: Scalars["String"];
  firstNameKana: Scalars["String"];
  lastName: Scalars["String"];
  lastNameKana: Scalars["String"];
  middleName: Scalars["String"];
  middleNameKana: Scalars["String"];
  sub: Scalars["ID"];
  username: Scalars["String"];
};

export type AdminUsersAtMikatanoId = {
  __typename?: "AdminUsersAtMikatanoID";
  adminUsers: Array<Maybe<AdminUserAtMikatanoId>>;
};

export type Alert = {
  __typename?: "Alert";
  alertID: Scalars["Int"];
  alertType: AlertType;
  code: AlertCode;
  linkType: AlertLinkType;
  linkURL: Scalars["String"];
  message: Scalars["String"];
};

export enum AlertCode {
  FirstBillingNg = "FirstBillingNG",
  ReversalNg = "ReversalNG",
  SecondBillingNg = "SecondBillingNG",
  Suspended = "Suspended",
}

export enum AlertLinkType {
  External = "external",
  Internal = "internal",
  None = "none",
}

export enum AlertType {
  Info = "info",
  Warning = "warning",
}

export type AppliedCoupon = {
  __typename?: "AppliedCoupon";
  applicatedOnFrom: Scalars["Date"];
  applicatedOnTo?: Maybe<Scalars["Date"]>;
  coupon?: Maybe<Coupon>;
  id: Scalars["ID"];
};

export type BankServices = {
  __typename?: "BankServices";
  bankCode: Scalars["BankCode"];
  coupons: Array<Maybe<Coupon>>;
  options: Array<Maybe<Option>>;
  plans: Array<Maybe<Plan>>;
  services: Array<Maybe<Service>>;
};

export type Billing = {
  __typename?: "Billing";
  amount: Scalars["Int"];
  billingDetails?: Maybe<Array<Maybe<BillingDetail>>>;
  billingOn?: Maybe<Scalars["Date"]>;
  id: Scalars["ID"];
  requestCount: Scalars["Int"];
  status: BillingStatus;
  taxAmount: Scalars["Int"];
  usingMonth: Scalars["String"];
};

export type BillingDetail = {
  __typename?: "BillingDetail";
  amount: Scalars["Int"];
  content: Scalars["String"];
  id: Scalars["ID"];
  type: BillingDetailType;
};

export enum BillingDetailType {
  Coupon = "coupon",
  Option = "option",
  Plan = "plan",
}

export enum BillingStatus {
  Canceled = "canceled",
  InRequest = "inRequest",
  Init = "init",
  Ng = "ng",
  Ok = "ok",
  Unclaimed = "unclaimed",
}

export type CancelContractPayload = {
  __typename?: "CancelContractPayload";
  result: Scalars["Boolean"];
};

export type CancelOptionInput = {
  optionContractID: Scalars["ID"];
};

export type CancelOptionPayload = {
  __typename?: "CancelOptionPayload";
  result: Scalars["Boolean"];
};

export type CancelReversalPayload = {
  __typename?: "CancelReversalPayload";
  result: Scalars["Boolean"];
};

export type CanceledOptionContract = {
  __typename?: "CanceledOptionContract";
  id: Scalars["ID"];
  option?: Maybe<Option>;
  status: OptionContractStatus;
  usingDateFrom: Scalars["Date"];
  usingDateTo?: Maybe<Scalars["Date"]>;
};

export type CanceledPlanContract = {
  __typename?: "CanceledPlanContract";
  appliedCoupons?: Maybe<Array<Maybe<AppliedCoupon>>>;
  id: Scalars["ID"];
  plan?: Maybe<Plan>;
  status: PlanContractStatus;
  usingDateFrom: Scalars["Date"];
  usingDateTo?: Maybe<Scalars["Date"]>;
};

export enum CardRegistrationType {
  ChangePlan = "ChangePlan",
  ManageContract = "ManageContract",
  RegisterOption = "RegisterOption",
  RegisterPlan = "RegisterPlan",
}

export type ChangePlanContractInput = {
  couponID?: InputMaybe<Scalars["ID"]>;
  planID: Scalars["ID"];
};

export type ChangePlanContractPayload = {
  __typename?: "ChangePlanContractPayload";
  result: Scalars["Boolean"];
};

export type Company = {
  __typename?: "Company";
  admins?: Maybe<Array<Maybe<Admin>>>;
  availableServices?: Maybe<Array<Maybe<Service>>>;
  billings?: Maybe<Array<Maybe<Billing>>>;
  canceledOptionContracts?: Maybe<Array<Maybe<OptionContract>>>;
  canceledPlanContracts?: Maybe<Array<Maybe<PlanContract>>>;
  cardRegistered: Scalars["Boolean"];
  currentTotalAmount: Scalars["Int"];
  isFirstMonthOfContract: Scalars["Boolean"];
  nextMonthBilling: NextMonthBilling;
  optionContracts?: Maybe<Array<Maybe<OptionContract>>>;
  planContract?: Maybe<PlanContract>;
  status?: Maybe<CompanyStatus>;
  uuid: Scalars["CompanyUUID"];
};

export enum CompanyStatus {
  Active = "active",
  Suspended = "suspended",
  Unused = "unused",
}

export type Coupon = {
  __typename?: "Coupon";
  appliedCoupons?: Maybe<Array<Maybe<AppliedCoupon>>>;
  availablePeriodFrom: Scalars["Date"];
  availablePeriodTo?: Maybe<Scalars["Date"]>;
  bankCode: Scalars["BankCode"];
  code: Scalars["String"];
  discountPeriod?: Maybe<Scalars["Int"]>;
  discountPeriodTo?: Maybe<Scalars["Date"]>;
  discountType: CouponDiscountType;
  id: Scalars["ID"];
  name: Scalars["String"];
  price: Scalars["Int"];
  priceIncludingTax: Scalars["Int"];
  status: CouponStatus;
  updatedBy: Scalars["String"];
};

export enum CouponDiscountType {
  Absolute = "absolute",
  Endless = "endless",
  Relative = "relative",
}

export enum CouponStatus {
  Active = "active",
  Draft = "draft",
  Inactive = "inactive",
}

export type DeleteAdminInput = {
  userSub: Scalars["String"];
};

export type DeleteAdminPayload = {
  __typename?: "DeleteAdminPayload";
  result: Scalars["Boolean"];
};

export type Feature = {
  __typename?: "Feature";
  code: Scalars["String"];
  displayOrder: Scalars["Int"];
  id: Scalars["ID"];
  name: Scalars["String"];
  status: FeatureStatus;
  type: FeatureType;
};

export enum FeatureStatus {
  Active = "active",
  Inactive = "inactive",
}

export enum FeatureType {
  Mikatano = "mikatano",
  Other = "other",
}

export type Mutation = {
  __typename?: "Mutation";
  addAdmin: AddAdminPayload;
  cancelContract: CancelContractPayload;
  cancelOption: CancelOptionPayload;
  cancelReversal: CancelReversalPayload;
  changePlanContract: ChangePlanContractPayload;
  deleteAdmin: DeleteAdminPayload;
  provisionalContract: ProvisionalContractPayload;
  provisionalOptionContract: ProvisionalOptionContractPayload;
};

export type MutationAddAdminArgs = {
  input?: InputMaybe<AddAdminInput>;
};

export type MutationCancelOptionArgs = {
  input?: InputMaybe<CancelOptionInput>;
};

export type MutationChangePlanContractArgs = {
  input?: InputMaybe<ChangePlanContractInput>;
};

export type MutationDeleteAdminArgs = {
  input?: InputMaybe<DeleteAdminInput>;
};

export type MutationProvisionalContractArgs = {
  input?: InputMaybe<ProvisionalContractInput>;
};

export type MutationProvisionalOptionContractArgs = {
  input?: InputMaybe<ProvisionalOptionContractInput>;
};

export type NextMonthBilling = {
  __typename?: "NextMonthBilling";
  billing: Billing;
  planAmount: Scalars["Int"];
  planName: Scalars["String"];
  planTaxAmount: Scalars["Int"];
};

export type Option = {
  __typename?: "Option";
  bankCode: Scalars["BankCode"];
  createdAt: Scalars["Date"];
  description?: Maybe<Scalars["String"]>;
  displayOrder?: Maybe<Scalars["Int"]>;
  id: Scalars["ID"];
  name: Scalars["String"];
  optionTerms?: Maybe<Array<Maybe<OptionTerm>>>;
  price: Scalars["Int"];
  priceIncludingTax: Scalars["Int"];
  publishedAtFrom: Scalars["Date"];
  publishedAtTo?: Maybe<Scalars["Date"]>;
  service?: Maybe<Service>;
  status: OptionStatus;
  updatedAt: Scalars["Date"];
};

export type OptionContract = {
  __typename?: "OptionContract";
  id: Scalars["ID"];
  option?: Maybe<Option>;
  status: OptionContractStatus;
  usingDateFrom: Scalars["Date"];
  usingDateTo?: Maybe<Scalars["Date"]>;
};

export enum OptionContractStatus {
  Contracted = "contracted",
  ProvisionalContract = "provisionalContract",
}

export enum OptionStatus {
  Active = "active",
  Draft = "draft",
  Inactive = "inactive",
}

export type OptionTerm = {
  __typename?: "OptionTerm";
  id: Scalars["ID"];
  linkText: Scalars["String"];
  url: Scalars["String"];
};

export type Plan = {
  __typename?: "Plan";
  bankCode: Scalars["BankCode"];
  createdAt: Scalars["Date"];
  description?: Maybe<Scalars["String"]>;
  displayOrder?: Maybe<Scalars["Int"]>;
  id: Scalars["ID"];
  name: Scalars["String"];
  price: Scalars["Int"];
  priceIncludingTax: Scalars["Int"];
  publishedAtFrom: Scalars["Date"];
  publishedAtTo?: Maybe<Scalars["Date"]>;
  services?: Maybe<Array<Maybe<Service>>>;
  status: PlanStatus;
  updatedAt: Scalars["Date"];
};

export type PlanContract = {
  __typename?: "PlanContract";
  appliedCoupons?: Maybe<Array<Maybe<AppliedCoupon>>>;
  id: Scalars["ID"];
  plan?: Maybe<Plan>;
  status: PlanContractStatus;
  usingDateFrom: Scalars["Date"];
  usingDateTo?: Maybe<Scalars["Date"]>;
};

export enum PlanContractStatus {
  Contracted = "contracted",
  ProvisionalContract = "provisionalContract",
}

export enum PlanStatus {
  Active = "active",
  Draft = "draft",
  Inactive = "inactive",
}

export type ProvisionalContractInput = {
  couponID?: InputMaybe<Scalars["ID"]>;
  optionIDs?: InputMaybe<Array<InputMaybe<Scalars["ID"]>>>;
  planID: Scalars["ID"];
};

export type ProvisionalContractPayload = {
  __typename?: "ProvisionalContractPayload";
  result: Scalars["Boolean"];
};

export type ProvisionalOptionContractInput = {
  optionIDs: Array<InputMaybe<Scalars["ID"]>>;
};

export type ProvisionalOptionContractPayload = {
  __typename?: "ProvisionalOptionContractPayload";
  result: Scalars["Boolean"];
};

export type Query = {
  __typename?: "Query";
  adminUsersAtMikatanoID: AdminUsersAtMikatanoId;
  alerts: Array<Maybe<Alert>>;
  bankServices: BankServices;
  cardRegistrationUrl: Scalars["String"];
  cardRegistrationUrlV2: Scalars["String"];
  company: Company;
  isCouponCodeAvailable: Scalars["Boolean"];
  now: Scalars["Date"];
};

export type QueryBankServicesArgs = {
  bankcode?: InputMaybe<Scalars["BankCode"]>;
};

export type QueryCardRegistrationUrlArgs = {
  app: Scalars["String"];
  cardRegistrationType: CardRegistrationType;
};

export type QueryCardRegistrationUrlV2Args = {
  app: Scalars["String"];
  bankName: Scalars["String"];
  cardRegistrationType: CardRegistrationType;
};

export type QueryIsCouponCodeAvailableArgs = {
  bankCode: Scalars["BankCode"];
  couponCode: Scalars["String"];
};

export enum Role {
  AdminUser = "ADMIN_USER",
  Invalid = "INVALID",
  PublicUser = "PUBLIC_USER",
}

export type Service = {
  __typename?: "Service";
  allFeatures: Array<Feature>;
  code: Scalars["String"];
  displayOrder: Scalars["Int"];
  id: Scalars["ID"];
  name: Scalars["String"];
  option?: Maybe<Option>;
  planFeatures: Array<Feature>;
  plans?: Maybe<Array<Maybe<Plan>>>;
  status: ServiceStatus;
  type: ServiceType;
};

export enum ServiceStatus {
  Active = "active",
  Inactive = "inactive",
}

export enum ServiceType {
  Mikatano = "mikatano",
  Option = "option",
  Other = "other",
}

export type ProvisionalContractMutationVariables = Exact<{
  input?: InputMaybe<ProvisionalContractInput>;
}>;

export type ProvisionalContractMutation = {
  __typename?: "Mutation";
  provisionalContract: {
    __typename?: "ProvisionalContractPayload";
    result: boolean;
  };
};

export type CancelContractMutationVariables = Exact<{ [key: string]: never }>;

export type CancelContractMutation = {
  __typename?: "Mutation";
  cancelContract: { __typename?: "CancelContractPayload"; result: boolean };
};

export type CancelReversalMutationVariables = Exact<{ [key: string]: never }>;

export type CancelReversalMutation = {
  __typename?: "Mutation";
  cancelReversal: { __typename?: "CancelReversalPayload"; result: boolean };
};

export type ChangePlanContractMutationVariables = Exact<{
  input?: InputMaybe<ChangePlanContractInput>;
}>;

export type ChangePlanContractMutation = {
  __typename?: "Mutation";
  changePlanContract: {
    __typename?: "ChangePlanContractPayload";
    result: boolean;
  };
};

export type ProvisionalOptionContractMutationVariables = Exact<{
  input?: InputMaybe<ProvisionalOptionContractInput>;
}>;

export type ProvisionalOptionContractMutation = {
  __typename?: "Mutation";
  provisionalOptionContract: {
    __typename?: "ProvisionalOptionContractPayload";
    result: boolean;
  };
};

export type CancelOptionMutationVariables = Exact<{
  input?: InputMaybe<CancelOptionInput>;
}>;

export type CancelOptionMutation = {
  __typename?: "Mutation";
  cancelOption: { __typename?: "CancelOptionPayload"; result: boolean };
};

export type AddAdminMutationVariables = Exact<{
  input?: InputMaybe<AddAdminInput>;
}>;

export type AddAdminMutation = {
  __typename?: "Mutation";
  addAdmin: { __typename?: "AddAdminPayload"; result: boolean };
};

export type DeleteAdminMutationVariables = Exact<{
  input?: InputMaybe<DeleteAdminInput>;
}>;

export type DeleteAdminMutation = {
  __typename?: "Mutation";
  deleteAdmin: { __typename?: "DeleteAdminPayload"; result: boolean };
};

export type BankServicesQueryVariables = Exact<{
  bankcode: Scalars["BankCode"];
}>;

export type BankServicesQuery = {
  __typename?: "Query";
  bankServices: {
    __typename?: "BankServices";
    bankCode: any;
    services: Array<{
      __typename?: "Service";
      id: string;
      name: string;
      type: ServiceType;
      code: string;
      status: ServiceStatus;
      displayOrder: number;
      allFeatures: Array<{
        __typename?: "Feature";
        id: string;
        name: string;
        type: FeatureType;
        code: string;
        status: FeatureStatus;
        displayOrder: number;
      }>;
      planFeatures: Array<{
        __typename?: "Feature";
        id: string;
        name: string;
        type: FeatureType;
        code: string;
        status: FeatureStatus;
        displayOrder: number;
      }>;
    } | null>;
    plans: Array<{
      __typename?: "Plan";
      id: string;
      bankCode: any;
      name: string;
      price: number;
      priceIncludingTax: number;
      status: PlanStatus;
      publishedAtFrom: any;
      publishedAtTo?: any | null;
      description?: string | null;
      displayOrder?: number | null;
      createdAt: any;
      updatedAt: any;
      services?: Array<{
        __typename?: "Service";
        id: string;
        name: string;
        type: ServiceType;
        code: string;
        status: ServiceStatus;
        displayOrder: number;
        allFeatures: Array<{
          __typename?: "Feature";
          id: string;
          name: string;
          type: FeatureType;
          code: string;
          status: FeatureStatus;
          displayOrder: number;
        }>;
        planFeatures: Array<{
          __typename?: "Feature";
          id: string;
          name: string;
          type: FeatureType;
          code: string;
          status: FeatureStatus;
          displayOrder: number;
        }>;
      } | null> | null;
    } | null>;
    options: Array<{
      __typename?: "Option";
      id: string;
      bankCode: any;
      name: string;
      price: number;
      priceIncludingTax: number;
      status: OptionStatus;
      publishedAtFrom: any;
      publishedAtTo?: any | null;
      description?: string | null;
      displayOrder?: number | null;
      createdAt: any;
      updatedAt: any;
      service?: {
        __typename?: "Service";
        id: string;
        name: string;
        type: ServiceType;
        code: string;
        status: ServiceStatus;
        displayOrder: number;
        allFeatures: Array<{
          __typename?: "Feature";
          id: string;
          name: string;
          type: FeatureType;
          code: string;
          status: FeatureStatus;
          displayOrder: number;
        }>;
        planFeatures: Array<{
          __typename?: "Feature";
          id: string;
          name: string;
          type: FeatureType;
          code: string;
          status: FeatureStatus;
          displayOrder: number;
        }>;
      } | null;
      optionTerms?: Array<{
        __typename?: "OptionTerm";
        id: string;
        linkText: string;
        url: string;
      } | null> | null;
    } | null>;
    coupons: Array<{
      __typename?: "Coupon";
      id: string;
      bankCode: any;
      code: string;
      name: string;
      price: number;
      priceIncludingTax: number;
      status: CouponStatus;
      discountType: CouponDiscountType;
      discountPeriod?: number | null;
      discountPeriodTo?: any | null;
      availablePeriodFrom: any;
      availablePeriodTo?: any | null;
      updatedBy: string;
    } | null>;
  };
};

export type CompanyQueryVariables = Exact<{ [key: string]: never }>;

export type CompanyQuery = {
  __typename?: "Query";
  company: {
    __typename?: "Company";
    uuid: any;
    status?: CompanyStatus | null;
    cardRegistered: boolean;
    isFirstMonthOfContract: boolean;
    currentTotalAmount: number;
    admins?: Array<{
      __typename?: "Admin";
      userSub: string;
      name: string;
    } | null> | null;
    billings?: Array<{
      __typename?: "Billing";
      id: string;
      usingMonth: string;
      requestCount: number;
      billingOn?: any | null;
      amount: number;
      status: BillingStatus;
      taxAmount: number;
      billingDetails?: Array<{
        __typename?: "BillingDetail";
        id: string;
        type: BillingDetailType;
        content: string;
        amount: number;
      } | null> | null;
    } | null> | null;
    optionContracts?: Array<{
      __typename?: "OptionContract";
      id: string;
      status: OptionContractStatus;
      usingDateFrom: any;
      usingDateTo?: any | null;
      option?: {
        __typename?: "Option";
        id: string;
        bankCode: any;
        name: string;
        price: number;
        priceIncludingTax: number;
        status: OptionStatus;
        publishedAtFrom: any;
        publishedAtTo?: any | null;
        description?: string | null;
        displayOrder?: number | null;
        createdAt: any;
        updatedAt: any;
        service?: {
          __typename?: "Service";
          id: string;
          name: string;
          type: ServiceType;
          code: string;
          status: ServiceStatus;
          displayOrder: number;
          allFeatures: Array<{
            __typename?: "Feature";
            id: string;
            name: string;
            type: FeatureType;
            code: string;
            status: FeatureStatus;
            displayOrder: number;
          }>;
          planFeatures: Array<{
            __typename?: "Feature";
            id: string;
            name: string;
            type: FeatureType;
            code: string;
            status: FeatureStatus;
            displayOrder: number;
          }>;
        } | null;
        optionTerms?: Array<{
          __typename?: "OptionTerm";
          id: string;
          linkText: string;
          url: string;
        } | null> | null;
      } | null;
    } | null> | null;
    canceledOptionContracts?: Array<{
      __typename?: "OptionContract";
      id: string;
      status: OptionContractStatus;
      usingDateFrom: any;
      usingDateTo?: any | null;
      option?: {
        __typename?: "Option";
        id: string;
        bankCode: any;
        name: string;
        price: number;
        priceIncludingTax: number;
        status: OptionStatus;
        publishedAtFrom: any;
        publishedAtTo?: any | null;
        description?: string | null;
        displayOrder?: number | null;
        createdAt: any;
        updatedAt: any;
        service?: {
          __typename?: "Service";
          id: string;
          name: string;
          type: ServiceType;
          code: string;
          status: ServiceStatus;
          displayOrder: number;
          allFeatures: Array<{
            __typename?: "Feature";
            id: string;
            name: string;
            type: FeatureType;
            code: string;
            status: FeatureStatus;
            displayOrder: number;
          }>;
          planFeatures: Array<{
            __typename?: "Feature";
            id: string;
            name: string;
            type: FeatureType;
            code: string;
            status: FeatureStatus;
            displayOrder: number;
          }>;
        } | null;
        optionTerms?: Array<{
          __typename?: "OptionTerm";
          id: string;
          linkText: string;
          url: string;
        } | null> | null;
      } | null;
    } | null> | null;
    planContract?: {
      __typename?: "PlanContract";
      id: string;
      status: PlanContractStatus;
      usingDateFrom: any;
      usingDateTo?: any | null;
      appliedCoupons?: Array<{
        __typename?: "AppliedCoupon";
        id: string;
        applicatedOnFrom: any;
        applicatedOnTo?: any | null;
        coupon?: {
          __typename?: "Coupon";
          id: string;
          bankCode: any;
          code: string;
          name: string;
          price: number;
          priceIncludingTax: number;
          status: CouponStatus;
          discountType: CouponDiscountType;
          discountPeriod?: number | null;
          discountPeriodTo?: any | null;
          availablePeriodFrom: any;
          availablePeriodTo?: any | null;
          updatedBy: string;
        } | null;
      } | null> | null;
      plan?: {
        __typename?: "Plan";
        id: string;
        bankCode: any;
        name: string;
        price: number;
        priceIncludingTax: number;
        status: PlanStatus;
        publishedAtFrom: any;
        publishedAtTo?: any | null;
        description?: string | null;
        displayOrder?: number | null;
        createdAt: any;
        updatedAt: any;
        services?: Array<{
          __typename?: "Service";
          id: string;
          name: string;
          type: ServiceType;
          code: string;
          status: ServiceStatus;
          displayOrder: number;
          allFeatures: Array<{
            __typename?: "Feature";
            id: string;
            name: string;
            type: FeatureType;
            code: string;
            status: FeatureStatus;
            displayOrder: number;
          }>;
          planFeatures: Array<{
            __typename?: "Feature";
            id: string;
            name: string;
            type: FeatureType;
            code: string;
            status: FeatureStatus;
            displayOrder: number;
          }>;
        } | null> | null;
      } | null;
    } | null;
    canceledPlanContracts?: Array<{
      __typename?: "PlanContract";
      id: string;
      status: PlanContractStatus;
      usingDateFrom: any;
      usingDateTo?: any | null;
      appliedCoupons?: Array<{
        __typename?: "AppliedCoupon";
        id: string;
        applicatedOnFrom: any;
        applicatedOnTo?: any | null;
        coupon?: {
          __typename?: "Coupon";
          id: string;
          bankCode: any;
          code: string;
          name: string;
          price: number;
          priceIncludingTax: number;
          status: CouponStatus;
          discountType: CouponDiscountType;
          discountPeriod?: number | null;
          discountPeriodTo?: any | null;
          availablePeriodFrom: any;
          availablePeriodTo?: any | null;
          updatedBy: string;
        } | null;
      } | null> | null;
      plan?: {
        __typename?: "Plan";
        id: string;
        bankCode: any;
        name: string;
        price: number;
        priceIncludingTax: number;
        status: PlanStatus;
        publishedAtFrom: any;
        publishedAtTo?: any | null;
        description?: string | null;
        displayOrder?: number | null;
        createdAt: any;
        updatedAt: any;
        services?: Array<{
          __typename?: "Service";
          id: string;
          name: string;
          type: ServiceType;
          code: string;
          status: ServiceStatus;
          displayOrder: number;
          allFeatures: Array<{
            __typename?: "Feature";
            id: string;
            name: string;
            type: FeatureType;
            code: string;
            status: FeatureStatus;
            displayOrder: number;
          }>;
          planFeatures: Array<{
            __typename?: "Feature";
            id: string;
            name: string;
            type: FeatureType;
            code: string;
            status: FeatureStatus;
            displayOrder: number;
          }>;
        } | null> | null;
      } | null;
    } | null> | null;
    availableServices?: Array<{
      __typename?: "Service";
      id: string;
      name: string;
      type: ServiceType;
      code: string;
      status: ServiceStatus;
      displayOrder: number;
      allFeatures: Array<{
        __typename?: "Feature";
        id: string;
        name: string;
        type: FeatureType;
        code: string;
        status: FeatureStatus;
        displayOrder: number;
      }>;
      planFeatures: Array<{
        __typename?: "Feature";
        id: string;
        name: string;
        type: FeatureType;
        code: string;
        status: FeatureStatus;
        displayOrder: number;
      }>;
    } | null> | null;
    nextMonthBilling: {
      __typename?: "NextMonthBilling";
      planName: string;
      planAmount: number;
      planTaxAmount: number;
      billing: {
        __typename?: "Billing";
        usingMonth: string;
        billingOn?: any | null;
        amount: number;
        taxAmount: number;
        billingDetails?: Array<{
          __typename?: "BillingDetail";
          type: BillingDetailType;
          content: string;
          amount: number;
        } | null> | null;
      };
    };
  };
};

export type AdminUsersAtMikatanoIdQueryVariables = Exact<{
  [key: string]: never;
}>;

export type AdminUsersAtMikatanoIdQuery = {
  __typename?: "Query";
  adminUsersAtMikatanoID: {
    __typename?: "AdminUsersAtMikatanoID";
    adminUsers: Array<{
      __typename?: "AdminUserAtMikatanoID";
      sub: string;
      username: string;
      email: string;
      lastName: string;
      lastNameKana: string;
      firstName: string;
      firstNameKana: string;
      middleName: string;
      middleNameKana: string;
    } | null>;
  };
};

export type CardRegistrationUrlQueryVariables = Exact<{
  cardRegistrationType: CardRegistrationType;
  app: Scalars["String"];
}>;

export type CardRegistrationUrlQuery = {
  __typename?: "Query";
  cardRegistrationUrl: string;
};

export type CardRegistrationUrlV2QueryVariables = Exact<{
  bankName: Scalars["String"];
  cardRegistrationType: CardRegistrationType;
  app: Scalars["String"];
}>;

export type CardRegistrationUrlV2Query = {
  __typename?: "Query";
  cardRegistrationUrlV2: string;
};

export type AlertsQueryVariables = Exact<{ [key: string]: never }>;

export type AlertsQuery = {
  __typename?: "Query";
  alerts: Array<{
    __typename?: "Alert";
    alertID: number;
    alertType: AlertType;
    message: string;
    linkType: AlertLinkType;
    linkURL: string;
    code: AlertCode;
  } | null>;
};

export type NowQueryVariables = Exact<{ [key: string]: never }>;

export type NowQuery = { __typename?: "Query"; now: any };

export type IsCouponCodeAvailableQueryVariables = Exact<{
  bankCode: Scalars["BankCode"];
  couponCode: Scalars["String"];
}>;

export type IsCouponCodeAvailableQuery = {
  __typename?: "Query";
  isCouponCodeAvailable: boolean;
};

export const ProvisionalContractDocument = gql`
  mutation provisionalContract($input: ProvisionalContractInput) {
    provisionalContract(input: $input) {
      result
    }
  }
`;
export type ProvisionalContractMutationFn = Apollo.MutationFunction<
  ProvisionalContractMutation,
  ProvisionalContractMutationVariables
>;

/**
 * __useProvisionalContractMutation__
 *
 * To run a mutation, you first call `useProvisionalContractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProvisionalContractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [provisionalContractMutation, { data, loading, error }] = useProvisionalContractMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useProvisionalContractMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ProvisionalContractMutation,
    ProvisionalContractMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ProvisionalContractMutation,
    ProvisionalContractMutationVariables
  >(ProvisionalContractDocument, options);
}
export type ProvisionalContractMutationHookResult = ReturnType<
  typeof useProvisionalContractMutation
>;
export type ProvisionalContractMutationResult =
  Apollo.MutationResult<ProvisionalContractMutation>;
export type ProvisionalContractMutationOptions = Apollo.BaseMutationOptions<
  ProvisionalContractMutation,
  ProvisionalContractMutationVariables
>;
export const CancelContractDocument = gql`
  mutation cancelContract {
    cancelContract {
      result
    }
  }
`;
export type CancelContractMutationFn = Apollo.MutationFunction<
  CancelContractMutation,
  CancelContractMutationVariables
>;

/**
 * __useCancelContractMutation__
 *
 * To run a mutation, you first call `useCancelContractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelContractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelContractMutation, { data, loading, error }] = useCancelContractMutation({
 *   variables: {
 *   },
 * });
 */
export function useCancelContractMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CancelContractMutation,
    CancelContractMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CancelContractMutation,
    CancelContractMutationVariables
  >(CancelContractDocument, options);
}
export type CancelContractMutationHookResult = ReturnType<
  typeof useCancelContractMutation
>;
export type CancelContractMutationResult =
  Apollo.MutationResult<CancelContractMutation>;
export type CancelContractMutationOptions = Apollo.BaseMutationOptions<
  CancelContractMutation,
  CancelContractMutationVariables
>;
export const CancelReversalDocument = gql`
  mutation cancelReversal {
    cancelReversal {
      result
    }
  }
`;
export type CancelReversalMutationFn = Apollo.MutationFunction<
  CancelReversalMutation,
  CancelReversalMutationVariables
>;

/**
 * __useCancelReversalMutation__
 *
 * To run a mutation, you first call `useCancelReversalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelReversalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelReversalMutation, { data, loading, error }] = useCancelReversalMutation({
 *   variables: {
 *   },
 * });
 */
export function useCancelReversalMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CancelReversalMutation,
    CancelReversalMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CancelReversalMutation,
    CancelReversalMutationVariables
  >(CancelReversalDocument, options);
}
export type CancelReversalMutationHookResult = ReturnType<
  typeof useCancelReversalMutation
>;
export type CancelReversalMutationResult =
  Apollo.MutationResult<CancelReversalMutation>;
export type CancelReversalMutationOptions = Apollo.BaseMutationOptions<
  CancelReversalMutation,
  CancelReversalMutationVariables
>;
export const ChangePlanContractDocument = gql`
  mutation changePlanContract($input: ChangePlanContractInput) {
    changePlanContract(input: $input) {
      result
    }
  }
`;
export type ChangePlanContractMutationFn = Apollo.MutationFunction<
  ChangePlanContractMutation,
  ChangePlanContractMutationVariables
>;

/**
 * __useChangePlanContractMutation__
 *
 * To run a mutation, you first call `useChangePlanContractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangePlanContractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changePlanContractMutation, { data, loading, error }] = useChangePlanContractMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useChangePlanContractMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ChangePlanContractMutation,
    ChangePlanContractMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ChangePlanContractMutation,
    ChangePlanContractMutationVariables
  >(ChangePlanContractDocument, options);
}
export type ChangePlanContractMutationHookResult = ReturnType<
  typeof useChangePlanContractMutation
>;
export type ChangePlanContractMutationResult =
  Apollo.MutationResult<ChangePlanContractMutation>;
export type ChangePlanContractMutationOptions = Apollo.BaseMutationOptions<
  ChangePlanContractMutation,
  ChangePlanContractMutationVariables
>;
export const ProvisionalOptionContractDocument = gql`
  mutation provisionalOptionContract($input: ProvisionalOptionContractInput) {
    provisionalOptionContract(input: $input) {
      result
    }
  }
`;
export type ProvisionalOptionContractMutationFn = Apollo.MutationFunction<
  ProvisionalOptionContractMutation,
  ProvisionalOptionContractMutationVariables
>;

/**
 * __useProvisionalOptionContractMutation__
 *
 * To run a mutation, you first call `useProvisionalOptionContractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProvisionalOptionContractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [provisionalOptionContractMutation, { data, loading, error }] = useProvisionalOptionContractMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useProvisionalOptionContractMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ProvisionalOptionContractMutation,
    ProvisionalOptionContractMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ProvisionalOptionContractMutation,
    ProvisionalOptionContractMutationVariables
  >(ProvisionalOptionContractDocument, options);
}
export type ProvisionalOptionContractMutationHookResult = ReturnType<
  typeof useProvisionalOptionContractMutation
>;
export type ProvisionalOptionContractMutationResult =
  Apollo.MutationResult<ProvisionalOptionContractMutation>;
export type ProvisionalOptionContractMutationOptions =
  Apollo.BaseMutationOptions<
    ProvisionalOptionContractMutation,
    ProvisionalOptionContractMutationVariables
  >;
export const CancelOptionDocument = gql`
  mutation cancelOption($input: CancelOptionInput) {
    cancelOption(input: $input) {
      result
    }
  }
`;
export type CancelOptionMutationFn = Apollo.MutationFunction<
  CancelOptionMutation,
  CancelOptionMutationVariables
>;

/**
 * __useCancelOptionMutation__
 *
 * To run a mutation, you first call `useCancelOptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelOptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelOptionMutation, { data, loading, error }] = useCancelOptionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCancelOptionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CancelOptionMutation,
    CancelOptionMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CancelOptionMutation,
    CancelOptionMutationVariables
  >(CancelOptionDocument, options);
}
export type CancelOptionMutationHookResult = ReturnType<
  typeof useCancelOptionMutation
>;
export type CancelOptionMutationResult =
  Apollo.MutationResult<CancelOptionMutation>;
export type CancelOptionMutationOptions = Apollo.BaseMutationOptions<
  CancelOptionMutation,
  CancelOptionMutationVariables
>;
export const AddAdminDocument = gql`
  mutation addAdmin($input: AddAdminInput) {
    addAdmin(input: $input) {
      result
    }
  }
`;
export type AddAdminMutationFn = Apollo.MutationFunction<
  AddAdminMutation,
  AddAdminMutationVariables
>;

/**
 * __useAddAdminMutation__
 *
 * To run a mutation, you first call `useAddAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addAdminMutation, { data, loading, error }] = useAddAdminMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddAdminMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AddAdminMutation,
    AddAdminMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<AddAdminMutation, AddAdminMutationVariables>(
    AddAdminDocument,
    options
  );
}
export type AddAdminMutationHookResult = ReturnType<typeof useAddAdminMutation>;
export type AddAdminMutationResult = Apollo.MutationResult<AddAdminMutation>;
export type AddAdminMutationOptions = Apollo.BaseMutationOptions<
  AddAdminMutation,
  AddAdminMutationVariables
>;
export const DeleteAdminDocument = gql`
  mutation deleteAdmin($input: DeleteAdminInput) {
    deleteAdmin(input: $input) {
      result
    }
  }
`;
export type DeleteAdminMutationFn = Apollo.MutationFunction<
  DeleteAdminMutation,
  DeleteAdminMutationVariables
>;

/**
 * __useDeleteAdminMutation__
 *
 * To run a mutation, you first call `useDeleteAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAdminMutation, { data, loading, error }] = useDeleteAdminMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteAdminMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteAdminMutation,
    DeleteAdminMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteAdminMutation, DeleteAdminMutationVariables>(
    DeleteAdminDocument,
    options
  );
}
export type DeleteAdminMutationHookResult = ReturnType<
  typeof useDeleteAdminMutation
>;
export type DeleteAdminMutationResult =
  Apollo.MutationResult<DeleteAdminMutation>;
export type DeleteAdminMutationOptions = Apollo.BaseMutationOptions<
  DeleteAdminMutation,
  DeleteAdminMutationVariables
>;
export const BankServicesDocument = gql`
  query bankServices($bankcode: BankCode!) {
    bankServices(bankcode: $bankcode) {
      bankCode
      services {
        id
        name
        type
        code
        status
        displayOrder
        allFeatures {
          id
          name
          type
          code
          status
          displayOrder
        }
        planFeatures {
          id
          name
          type
          code
          status
          displayOrder
        }
      }
      plans {
        id
        bankCode
        name
        price
        priceIncludingTax
        status
        publishedAtFrom
        publishedAtTo
        description
        displayOrder
        createdAt
        updatedAt
        services {
          id
          name
          type
          code
          status
          displayOrder
          allFeatures {
            id
            name
            type
            code
            status
            displayOrder
          }
          planFeatures {
            id
            name
            type
            code
            status
            displayOrder
          }
        }
      }
      options {
        id
        bankCode
        name
        price
        priceIncludingTax
        status
        publishedAtFrom
        publishedAtTo
        description
        displayOrder
        createdAt
        updatedAt
        service {
          id
          name
          type
          code
          status
          displayOrder
          allFeatures {
            id
            name
            type
            code
            status
            displayOrder
          }
          planFeatures {
            id
            name
            type
            code
            status
            displayOrder
          }
        }
        optionTerms {
          id
          linkText
          url
        }
      }
      coupons {
        id
        bankCode
        code
        name
        price
        priceIncludingTax
        status
        discountType
        discountPeriod
        discountPeriodTo
        availablePeriodFrom
        availablePeriodTo
        updatedBy
      }
    }
  }
`;

/**
 * __useBankServicesQuery__
 *
 * To run a query within a React component, call `useBankServicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useBankServicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBankServicesQuery({
 *   variables: {
 *      bankcode: // value for 'bankcode'
 *   },
 * });
 */
export function useBankServicesQuery(
  baseOptions: Apollo.QueryHookOptions<
    BankServicesQuery,
    BankServicesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<BankServicesQuery, BankServicesQueryVariables>(
    BankServicesDocument,
    options
  );
}
export function useBankServicesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    BankServicesQuery,
    BankServicesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<BankServicesQuery, BankServicesQueryVariables>(
    BankServicesDocument,
    options
  );
}
export type BankServicesQueryHookResult = ReturnType<
  typeof useBankServicesQuery
>;
export type BankServicesLazyQueryHookResult = ReturnType<
  typeof useBankServicesLazyQuery
>;
export type BankServicesQueryResult = Apollo.QueryResult<
  BankServicesQuery,
  BankServicesQueryVariables
>;
export const CompanyDocument = gql`
  query company {
    company {
      uuid
      status
      cardRegistered
      isFirstMonthOfContract
      admins {
        userSub
        name
      }
      billings {
        id
        usingMonth
        requestCount
        billingOn
        amount
        status
        taxAmount
        billingDetails {
          id
          type
          content
          amount
        }
      }
      optionContracts {
        id
        status
        usingDateFrom
        usingDateTo
        option {
          id
          bankCode
          name
          price
          priceIncludingTax
          status
          publishedAtFrom
          publishedAtTo
          description
          displayOrder
          createdAt
          updatedAt
          service {
            id
            name
            type
            code
            status
            displayOrder
            allFeatures {
              id
              name
              type
              code
              status
              displayOrder
            }
            planFeatures {
              id
              name
              type
              code
              status
              displayOrder
            }
          }
          optionTerms {
            id
            linkText
            url
          }
        }
      }
      canceledOptionContracts {
        id
        status
        usingDateFrom
        usingDateTo
        option {
          id
          bankCode
          name
          price
          priceIncludingTax
          status
          publishedAtFrom
          publishedAtTo
          description
          displayOrder
          createdAt
          updatedAt
          service {
            id
            name
            type
            code
            status
            displayOrder
            allFeatures {
              id
              name
              type
              code
              status
              displayOrder
            }
            planFeatures {
              id
              name
              type
              code
              status
              displayOrder
            }
          }
          optionTerms {
            id
            linkText
            url
          }
        }
      }
      planContract {
        id
        status
        usingDateFrom
        usingDateTo
        appliedCoupons {
          id
          applicatedOnFrom
          applicatedOnTo
          coupon {
            id
            bankCode
            code
            name
            price
            priceIncludingTax
            status
            discountType
            discountPeriod
            discountPeriodTo
            availablePeriodFrom
            availablePeriodTo
            updatedBy
          }
        }
        plan {
          id
          bankCode
          name
          price
          priceIncludingTax
          status
          publishedAtFrom
          publishedAtTo
          description
          displayOrder
          createdAt
          updatedAt
          services {
            id
            name
            type
            code
            status
            displayOrder
            allFeatures {
              id
              name
              type
              code
              status
              displayOrder
            }
            planFeatures {
              id
              name
              type
              code
              status
              displayOrder
            }
          }
        }
      }
      canceledPlanContracts {
        id
        status
        usingDateFrom
        usingDateTo
        appliedCoupons {
          id
          applicatedOnFrom
          applicatedOnTo
          coupon {
            id
            bankCode
            code
            name
            price
            priceIncludingTax
            status
            discountType
            discountPeriod
            discountPeriodTo
            availablePeriodFrom
            availablePeriodTo
            updatedBy
          }
        }
        plan {
          id
          bankCode
          name
          price
          priceIncludingTax
          status
          publishedAtFrom
          publishedAtTo
          description
          displayOrder
          createdAt
          updatedAt
          services {
            id
            name
            type
            code
            status
            displayOrder
            allFeatures {
              id
              name
              type
              code
              status
              displayOrder
            }
            planFeatures {
              id
              name
              type
              code
              status
              displayOrder
            }
          }
        }
      }
      currentTotalAmount
      availableServices {
        id
        name
        type
        code
        status
        displayOrder
        allFeatures {
          id
          name
          type
          code
          status
          displayOrder
        }
        planFeatures {
          id
          name
          type
          code
          status
          displayOrder
        }
      }
      nextMonthBilling {
        planName
        planAmount
        planTaxAmount
        billing {
          usingMonth
          billingOn
          amount
          taxAmount
          billingDetails {
            type
            content
            amount
          }
        }
      }
    }
  }
`;

/**
 * __useCompanyQuery__
 *
 * To run a query within a React component, call `useCompanyQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyQuery({
 *   variables: {
 *   },
 * });
 */
export function useCompanyQuery(
  baseOptions?: Apollo.QueryHookOptions<CompanyQuery, CompanyQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<CompanyQuery, CompanyQueryVariables>(
    CompanyDocument,
    options
  );
}
export function useCompanyLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<CompanyQuery, CompanyQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<CompanyQuery, CompanyQueryVariables>(
    CompanyDocument,
    options
  );
}
export type CompanyQueryHookResult = ReturnType<typeof useCompanyQuery>;
export type CompanyLazyQueryHookResult = ReturnType<typeof useCompanyLazyQuery>;
export type CompanyQueryResult = Apollo.QueryResult<
  CompanyQuery,
  CompanyQueryVariables
>;
export const AdminUsersAtMikatanoIdDocument = gql`
  query adminUsersAtMikatanoID {
    adminUsersAtMikatanoID {
      adminUsers {
        sub
        username
        email
        lastName
        lastNameKana
        firstName
        firstNameKana
        middleName
        middleNameKana
      }
    }
  }
`;

/**
 * __useAdminUsersAtMikatanoIdQuery__
 *
 * To run a query within a React component, call `useAdminUsersAtMikatanoIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminUsersAtMikatanoIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminUsersAtMikatanoIdQuery({
 *   variables: {
 *   },
 * });
 */
export function useAdminUsersAtMikatanoIdQuery(
  baseOptions?: Apollo.QueryHookOptions<
    AdminUsersAtMikatanoIdQuery,
    AdminUsersAtMikatanoIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    AdminUsersAtMikatanoIdQuery,
    AdminUsersAtMikatanoIdQueryVariables
  >(AdminUsersAtMikatanoIdDocument, options);
}
export function useAdminUsersAtMikatanoIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AdminUsersAtMikatanoIdQuery,
    AdminUsersAtMikatanoIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    AdminUsersAtMikatanoIdQuery,
    AdminUsersAtMikatanoIdQueryVariables
  >(AdminUsersAtMikatanoIdDocument, options);
}
export type AdminUsersAtMikatanoIdQueryHookResult = ReturnType<
  typeof useAdminUsersAtMikatanoIdQuery
>;
export type AdminUsersAtMikatanoIdLazyQueryHookResult = ReturnType<
  typeof useAdminUsersAtMikatanoIdLazyQuery
>;
export type AdminUsersAtMikatanoIdQueryResult = Apollo.QueryResult<
  AdminUsersAtMikatanoIdQuery,
  AdminUsersAtMikatanoIdQueryVariables
>;
export const CardRegistrationUrlDocument = gql`
  query cardRegistrationUrl(
    $cardRegistrationType: CardRegistrationType!
    $app: String!
  ) {
    cardRegistrationUrl(cardRegistrationType: $cardRegistrationType, app: $app)
  }
`;

/**
 * __useCardRegistrationUrlQuery__
 *
 * To run a query within a React component, call `useCardRegistrationUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useCardRegistrationUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCardRegistrationUrlQuery({
 *   variables: {
 *      cardRegistrationType: // value for 'cardRegistrationType'
 *      app: // value for 'app'
 *   },
 * });
 */
export function useCardRegistrationUrlQuery(
  baseOptions: Apollo.QueryHookOptions<
    CardRegistrationUrlQuery,
    CardRegistrationUrlQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    CardRegistrationUrlQuery,
    CardRegistrationUrlQueryVariables
  >(CardRegistrationUrlDocument, options);
}
export function useCardRegistrationUrlLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CardRegistrationUrlQuery,
    CardRegistrationUrlQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CardRegistrationUrlQuery,
    CardRegistrationUrlQueryVariables
  >(CardRegistrationUrlDocument, options);
}
export type CardRegistrationUrlQueryHookResult = ReturnType<
  typeof useCardRegistrationUrlQuery
>;
export type CardRegistrationUrlLazyQueryHookResult = ReturnType<
  typeof useCardRegistrationUrlLazyQuery
>;
export type CardRegistrationUrlQueryResult = Apollo.QueryResult<
  CardRegistrationUrlQuery,
  CardRegistrationUrlQueryVariables
>;
export const CardRegistrationUrlV2Document = gql`
  query cardRegistrationUrlV2(
    $bankName: String!
    $cardRegistrationType: CardRegistrationType!
    $app: String!
  ) {
    cardRegistrationUrlV2(
      bankName: $bankName
      cardRegistrationType: $cardRegistrationType
      app: $app
    )
  }
`;

/**
 * __useCardRegistrationUrlV2Query__
 *
 * To run a query within a React component, call `useCardRegistrationUrlV2Query` and pass it any options that fit your needs.
 * When your component renders, `useCardRegistrationUrlV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCardRegistrationUrlV2Query({
 *   variables: {
 *      bankName: // value for 'bankName'
 *      cardRegistrationType: // value for 'cardRegistrationType'
 *      app: // value for 'app'
 *   },
 * });
 */
export function useCardRegistrationUrlV2Query(
  baseOptions: Apollo.QueryHookOptions<
    CardRegistrationUrlV2Query,
    CardRegistrationUrlV2QueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    CardRegistrationUrlV2Query,
    CardRegistrationUrlV2QueryVariables
  >(CardRegistrationUrlV2Document, options);
}
export function useCardRegistrationUrlV2LazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CardRegistrationUrlV2Query,
    CardRegistrationUrlV2QueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CardRegistrationUrlV2Query,
    CardRegistrationUrlV2QueryVariables
  >(CardRegistrationUrlV2Document, options);
}
export type CardRegistrationUrlV2QueryHookResult = ReturnType<
  typeof useCardRegistrationUrlV2Query
>;
export type CardRegistrationUrlV2LazyQueryHookResult = ReturnType<
  typeof useCardRegistrationUrlV2LazyQuery
>;
export type CardRegistrationUrlV2QueryResult = Apollo.QueryResult<
  CardRegistrationUrlV2Query,
  CardRegistrationUrlV2QueryVariables
>;
export const AlertsDocument = gql`
  query alerts {
    alerts {
      alertID
      alertType
      message
      linkType
      linkURL
      code
    }
  }
`;

/**
 * __useAlertsQuery__
 *
 * To run a query within a React component, call `useAlertsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAlertsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAlertsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAlertsQuery(
  baseOptions?: Apollo.QueryHookOptions<AlertsQuery, AlertsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<AlertsQuery, AlertsQueryVariables>(
    AlertsDocument,
    options
  );
}
export function useAlertsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<AlertsQuery, AlertsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<AlertsQuery, AlertsQueryVariables>(
    AlertsDocument,
    options
  );
}
export type AlertsQueryHookResult = ReturnType<typeof useAlertsQuery>;
export type AlertsLazyQueryHookResult = ReturnType<typeof useAlertsLazyQuery>;
export type AlertsQueryResult = Apollo.QueryResult<
  AlertsQuery,
  AlertsQueryVariables
>;
export const NowDocument = gql`
  query now {
    now
  }
`;

/**
 * __useNowQuery__
 *
 * To run a query within a React component, call `useNowQuery` and pass it any options that fit your needs.
 * When your component renders, `useNowQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNowQuery({
 *   variables: {
 *   },
 * });
 */
export function useNowQuery(
  baseOptions?: Apollo.QueryHookOptions<NowQuery, NowQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<NowQuery, NowQueryVariables>(NowDocument, options);
}
export function useNowLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<NowQuery, NowQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<NowQuery, NowQueryVariables>(NowDocument, options);
}
export type NowQueryHookResult = ReturnType<typeof useNowQuery>;
export type NowLazyQueryHookResult = ReturnType<typeof useNowLazyQuery>;
export type NowQueryResult = Apollo.QueryResult<NowQuery, NowQueryVariables>;
export const IsCouponCodeAvailableDocument = gql`
  query isCouponCodeAvailable($bankCode: BankCode!, $couponCode: String!) {
    isCouponCodeAvailable(bankCode: $bankCode, couponCode: $couponCode)
  }
`;

/**
 * __useIsCouponCodeAvailableQuery__
 *
 * To run a query within a React component, call `useIsCouponCodeAvailableQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsCouponCodeAvailableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsCouponCodeAvailableQuery({
 *   variables: {
 *      bankCode: // value for 'bankCode'
 *      couponCode: // value for 'couponCode'
 *   },
 * });
 */
export function useIsCouponCodeAvailableQuery(
  baseOptions: Apollo.QueryHookOptions<
    IsCouponCodeAvailableQuery,
    IsCouponCodeAvailableQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    IsCouponCodeAvailableQuery,
    IsCouponCodeAvailableQueryVariables
  >(IsCouponCodeAvailableDocument, options);
}
export function useIsCouponCodeAvailableLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    IsCouponCodeAvailableQuery,
    IsCouponCodeAvailableQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    IsCouponCodeAvailableQuery,
    IsCouponCodeAvailableQueryVariables
  >(IsCouponCodeAvailableDocument, options);
}
export type IsCouponCodeAvailableQueryHookResult = ReturnType<
  typeof useIsCouponCodeAvailableQuery
>;
export type IsCouponCodeAvailableLazyQueryHookResult = ReturnType<
  typeof useIsCouponCodeAvailableLazyQuery
>;
export type IsCouponCodeAvailableQueryResult = Apollo.QueryResult<
  IsCouponCodeAvailableQuery,
  IsCouponCodeAvailableQueryVariables
>;
